<template>
    <teleport to="body">
        <div
            v-if="showWrap"
            :class="[isWeb ? 'ignore-toast-wrap' : 'toast-wrap', showContent ? 'fadein' : 'fadeout']"
            :style="style"
        >
            {{ text }}
        </div>
    </teleport>
</template>

<style lang="scss" scoped>
.toast-wrap{
    position: fixed;
    left: 50%;
    top: 45%;
    background: rgba(0, 0, 0, 0.7);
    padding: 20px 40px;
    border-radius: 80px;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    z-index: 99999;
    font-size: 28px;
}
.ignore-toast-wrap {
    position: fixed;
    left: 50%;
    top: 45%;
    background: rgba(0, 0, 0, 0.7);
    padding: 20px 40px;
    border-radius: 40px;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    z-index: 99999;
    font-size: 22px;
}

.fadein {
    animation: animate_in 0.3s;
}
.fadeout {
    animation: animate_out 0.7s;
    opacity: 0;
}
@keyframes animate_in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes animate_out {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
</style>
